module.exports = {
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    {
      name: "google-site-verification",
      content: "FTf_VAGmkX6nvkYTl9S4vtCK-1Dy3N9kyOteR0poBE8"
    },
    {
      property: "og:title",
      content: "ICJIA Grant Accountability & Transparency Act"
    },
    {
      property: "og:site_name",
      content: "ICJIA Grant Accountability & Transparency Act"
    },
    { property: "og:url", content: "https://grants.icjia.cloud" },
    {
      property: "og:description",
      content: "ICJIA Grant Accountability & Transparency Act. "
    },
    { property: "fb:app_id", content: "963916987072512" },
    { property: "og:type", content: "article" },
    { property: "og:locale", content: "en_US" },
    { property: "article:author", content: "https://www.facebook.com/ICJIA" },
    {
      property: "og:image",
      content: "http://www.icjia.state.il.us/assets/img/icjia-default.jpg"
    }
  ],
  script: [],
  link: [
    {
      rel: "icon",
      type: "image/png",
      sizes: "192x192",
      href: "/static/icons/android-icon-192x192.png?v=1440170181"
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/static/icons/favicon-32x32.png?v=1440170181"
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "96x96",
      href: "/static/icons/favicon-96x96.png?v=1440170181"
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/static/icons/favicon-16x16.png?v=1440170181"
    }
  ],
  // if no subcomponents specify a metaInfo.title, this title will be used
  title: "ICJIA Grant Accountability & Transparency Act",
  // all titles will be injected into this template
  titleTemplate: "ICJIA GATA | %s"
};



// WEBPACK FOOTER //
// ./src/meta/index.js